/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1PrintingsQueryResponse } from '../../types/GetV1Printings.ts'

export const getV1PrintingsQueryKey = () => [{ url: '/v1/Printings' }] as const

export type GetV1PrintingsQueryKey = ReturnType<typeof getV1PrintingsQueryKey>

/**
 * {@link /v1/Printings}
 */
export async function getV1Printings(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1PrintingsQueryResponse, ResponseErrorConfig<Error>, unknown>({
        method: 'GET',
        url: `/v1/Printings`,
        ...requestConfig,
    })
    return res
}

export function getV1PrintingsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1PrintingsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1PrintingsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1PrintingsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Printings(config)
        },
    })
}

/**
 * {@link /v1/Printings}
 */
export function useGetV1Printings<
    TData = ResponseConfig<GetV1PrintingsQueryResponse>,
    TQueryData = ResponseConfig<GetV1PrintingsQueryResponse>,
    TQueryKey extends QueryKey = GetV1PrintingsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1PrintingsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1PrintingsQueryKey()

    const query = useQuery(
        {
            ...getV1PrintingsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
